import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaButton from './VaButton.vue'

export const VaButton = withConfigTransport(_VaButton)
